export const serverPath = process.env.REACT_APP_serverPath;